import gql from 'graphql-tag'

export const LOCAL_LOGIN = gql`
  mutation logUserIn($token: String!) {
    logUserIn(token: $token) @client
  }
`;
